<template>
  <div class="back-to-list">
    <router-link :to="linkBackButton" class="color-icon form-row">
      <i class="fas fa-arrow-left icon-top-header mr-1"></i>
      <div class="my-auto arrow-desc">
        <p class="mb-0 p-2">{{$t("topHeader.backToDiariesList")}}</p>
      </div>
    </router-link>
  </div>
</template>

<script>
import backToListMixin from '@/mixins/backToListMixin'

export default {
  name: 'BackToListLink',
  mixins: [backToListMixin]
}
</script>
